function makeHttpObject() {
	try {
		return new XMLHttpRequest()
	} catch (error) {}
	try {
		return new ActiveXObject("Msxml2.XMLHTTP")
	} catch (error) {}
	try {
		return new ActiveXObject("Microsoft.XMLHTTP")
	} catch (error) {}

	throw new Error("Could not create HTTP request object.")
}

let doHttpRequest = (target, url, success, failure) => {
	var request = makeHttpObject()
	if (request) {
		request.onreadystatechange = () => {
			if (request.readyState == 4) {
				if (request.status === 200 || request.status === 0) success(target, request.responseText)
				else if (failure) failure(request.status, request.statusText)
			}
		}
		request.open("GET", url, true)
		request.send(null)
	}
}

export { doHttpRequest }
